import { IconButton, Stack, SxProps, Theme } from '@mui/material';
import {
  CandidateProfileListProps,
  CandidateProfileListType
} from 'modules/candidate-profile/types/CandidateProfileListProps';
import { candidateProfilePoolSx } from 'modules/candidate-profile/styles/candidateProfilePoolSx';
import { Header } from 'common/ui/Header';
import { DockPanelIcon } from 'components/Icons/DockPanelIcon';
import { CandidateProfileListTabs } from 'modules/candidate-profile/components/CandidateProfileListTabs';
import { SourceExternallyButton } from 'modules/sourcing-external/components/SourceExternallyButton';
import { useGetCandidateProfileTableHeaderOptions } from 'modules/candidate-profile/utils/useGetCandidateProfileTableHeaderOptions';
import { useSearchParams } from 'react-router-dom';
import { useNavigateWithHistory } from 'core/services/navigation/hooks/useNavigateWithHistory';

type CandidateProfileTableHeaderProps = {
  candidateProfileListProps: CandidateProfileListProps;
  conversationPanelOptions: {
    isConversationPanelCollapsed: boolean;
    handleToggleConversationPanel: () => void;
  } | null;
};

const headerSx = (hasConversationPanel: boolean): SxProps<Theme> => ({
  ...candidateProfilePoolSx.headerContainer,
  pr: hasConversationPanel ? '50px' : '0px'
});

export const CandidateProfileTableHeader: React.FC<
  CandidateProfileTableHeaderProps
> = ({ candidateProfileListProps, conversationPanelOptions }) => {
  const [searchParams] = useSearchParams();
  const { navigateBackWithParams } = useNavigateWithHistory();
  const { options } = useGetCandidateProfileTableHeaderOptions(
    candidateProfileListProps
  );
  const sessionId = searchParams.get('sessionId');

  const handleBack = () => {
    navigateBackWithParams({
      searchParams: sessionId ? { sessionId } : undefined
    });
  };

  return (
    <Stack
      justifyItems="stretch"
      gap="8px"
      sx={headerSx(!!conversationPanelOptions)}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Header
          sx={candidateProfilePoolSx.header}
          hideBreadcrumbs={options.hideBreadcrumbs}
          currentBreadcrumb={options.currentBreadcrumb}
          title={options.currentBreadcrumb}
          breadcrumbs={options.breadcrumbs}
          subtitle={options.subtitle}
          items={options.items}
          actions={options.actions}
          onBack={options.showBackButton ? handleBack : undefined}
        />
        <Stack direction="row" gap="8px" alignItems="center">
          {candidateProfileListProps.type ===
            CandidateProfileListType.ANALYSIS_CANDIDATES_LIST && (
            <SourceExternallyButton
              candidateBatchId={candidateProfileListProps.candidateBatchId}
            />
          )}
          {conversationPanelOptions && (
            <IconButton
              onClick={conversationPanelOptions.handleToggleConversationPanel}
              color="primary"
            >
              <DockPanelIcon />
            </IconButton>
          )}
        </Stack>
      </Stack>
      <CandidateProfileListTabs
        candidateProfileListProps={candidateProfileListProps}
      />
    </Stack>
  );
};
